'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noHTML = function noHTML() {

  return function (text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  };
};

exports.default = noHTML;


// WEBPACK FOOTER //
// ./client/app/common/filters/noHTML/noHTML.filter.js